import { DatoCmsPdv } from 'lib/datoCms/queries/getAllPdvLabels';
import { DatoCmsSignUp } from 'lib/datoCms/queries/getAllSignUpLabels';
import { LabelsMaximals } from '../LimitMaximal';

export const getLabelMaximals = (labels: DatoCmsSignUp | DatoCmsPdv): LabelsMaximals => {
  return {
    titleMaximals: labels.titleFourthForm,
    descriptionMaximals: labels.descriptionFourthForm,
    chipsLabel: labels.chipsLabel,
    anotherAmount: labels.anotherAmount,
    amountLimiter: labels.amountLimiter,
    labelMinLimitValue: labels.labelMinLimitValue,
    labelMaxLimitValue: labels.labelMaxLimitValue,
    limitMaxValue: labels.limitMaxValue,
    labelNoDecimal: labels.labelNoDecimal,
  };
};
